import React, { useEffect, useState } from "react";
import AutoLocation from "sr/helpers/ui-components/AutoLocation";
import { ModelWrapperWithButton } from "app/pages/company/component/ModelWrapperWithButton";
import { Button } from "sr/helpers/ui-components/company/Button";
import { Location } from "../Tables/Location";
import { LocationDetailsView } from "../LocationDetailsView";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormik } from "formik";
import { createCustomerLocation } from "sr/utils/api/company/customer/createCustomerLocation";
import { getCustomerLocation } from "sr/utils/api/company/customer/getCustomerLocation";
import { useParams } from "react-router-dom";
import CustomerLocationSchema from "sr/utils/schemas/company/customer/CustomerLocationSchema";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { updateCustomerLocation } from "sr/utils/api/company/customer/updateCustomerLocation";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { updateCustomer } from "sr/utils/api/company/customer/updateCustomer";
import { Pagination } from "app/pages/component/Pagination";
import { Input, Select } from "antd";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";
import { fetchContractor } from "sr/helpers/apiFunctions/contractor/fetchContractor";

export const LocationTab = (props) => {
  const intl = useIntl();
  const validationErrorHandle = useValidationErrorHandle();

  const [model, setModel] = useState(false);
  const [addlocation, setaddlocation] = useState(false);
  const [LocationView, setLocationView] = useState(false);

  const [customerId, setCustomerId] = useState(null);
  const [customerLocations, setCustomerLocations] = useState([]);
  const [locationId, setLocationId] = useState(null);

  const [loader, setLoader] = useState("");
  const [companyId, setCompanyId] = useState();

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPage, settotalPage] = useState<number>(0);

  const [contractors, setContractors] = useState([]);
  const [contractorsLoaded, setContractorsLoaded] = useState(false);

  const params = useParams();

  useEffect(() => {
    const { id } = params;
    setCustomerId(id);
  }, []);

  useEffect(() => {
    const { user_id } = getUserDetails();
    setCompanyId(user_id);
  }, []);

  const fetchAllContractors = async () => {
    if (contractorsLoaded) return;

    const { user_id } = getUserDetails();

    await fetchContractor({
      userType: "company",
      userId: user_id,
      page: 1,
      limit: 100,
      setData: setContractors,
    });

    setContractorsLoaded(true);
  };

  useEffect(() => {
    fetchAllContractors();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: locationId || "",
      customer_id: customerId || "",
      company_id: companyId || "",
      address: null,
      name: "",
      remarks: "",
      contractorIds: [],
    },
    validationSchema: CustomerLocationSchema,
    onSubmit: async (values) => {
      console.log("Values:", values);

      setLoader("submit");

      try {
        let result;

        if (locationId) {
          result = await updateCustomerLocation(values);
        } else {
          result = await createCustomerLocation(values);
        }

        if (result?.success) {
          if (!locationId) {
            await updateCustomer({
              id: customerId,
              status: "active",
            });
          }

          FetchCustomerLocations();

          formik.resetForm();

          setaddlocation(false);
          setLocationId(null);
          setLoader("");
        }
      } catch (e) {
        setLoader("");
      }
    },
  });

  const FetchCustomerLocations = async () => {
    setLoader("location");

    try {
      const queryParams = new URLSearchParams();

      queryParams.append("status!", "deleted");
      queryParams.append("limit", limit.toString());
      queryParams.append("page", page.toString());

      if (customerId) queryParams.append("customer_id", customerId);

      const result = await getCustomerLocation(queryParams);

      if (result?.success) {
        const filtered = result?.data?.filter(
          (location) => location.status !== "draft"
        );

        settotalPage(Math.ceil(result?.pagination?.total / limit));
        setCustomerLocations(filtered);
      }

      setLoader("");
    } catch {
      setLoader("");
    }
  };

  useEffect(() => {
    if (customerId) FetchCustomerLocations();
  }, [customerId, page]);

  const HandleAutoLocation = (data) => {
    formik.setFieldValue("address", data);
  };

  const HandleViewLocation = (id) => {
    setLocationId(id);
    setLocationView(true);
  };

  const HandleEditLocation = async (id) => {
    setLocationId(id);
    setaddlocation(true);

    try {
      const queryParams = new URLSearchParams();
      queryParams.append("id", id);

      const result = await getCustomerLocation(queryParams);

      if (result?.success) {
        const data = result.data;

        formik.setValues({
          id: data.id,
          customer_id: data.customer_id,
          company_id: data.company_id,
          address: data.address,
          name: data.name,
          remarks: data.remarks,
          contractorIds: (data.contractorIds || []).map((c) => c._id),
        });
      }
    } catch {}
  };

  const handleDeleteLocation = async (id) => {
    const result = await updateCustomerLocation({
      id,
      status: "deleted",
    });

    if (result?.success) FetchCustomerLocations();
  };

  const onCheckModel = () => {
    setaddlocation(false);
    setLocationView(false);
    setLocationId(null);
    formik.resetForm();
  };

  return (
    <>
      {loader === "submit" && <LoaderFullScreen />}

      <div className="py-4">
        <ModelWrapperWithButton
          showModal={addlocation}
          onCheckModel={onCheckModel}
          Save={formik.handleSubmit}
        >
          <form>
            <AutoLocation
              errors={formik.touched.address ? formik.errors?.address : null}
              HandleAutoLocation={HandleAutoLocation}
              address={formik.values.address}
              locationNameInput={
                <div className="mt-5">
                  <label className="mb-2 text-sm flex items-center">
                    Location Name
                  </label>

                  <Input
                    size="large"
                    value={formik.values.name}
                    onChange={(e) =>
                      formik.setFieldValue("name", e.target.value)
                    }
                  />

                  {formik.touched.name && formik.errors?.name && (
                    <p className="mt-1 text-red-400 text-sm">
                      {validationErrorHandle(formik.errors?.name)}
                    </p>
                  )}
                </div>
              }
            />

            <div className="mt-10">
              <label className="mb-2 text-sm flex items-center">
                <FormattedMessage
                  id="RECRUITER.CUSTOMER.LOCATION.ADD.CONTRACTORS"
                  defaultMessage="Add Contractors"
                />
              </label>

              <Select
                mode="multiple"
                style={{ width: "100%" }}
                value={formik.values.contractorIds}
                onDropdownVisibleChange={(open) => {
                  if (open) fetchAllContractors();
                }}
                onChange={(value) =>
                  formik.setFieldValue("contractorIds", value)
                }
                options={contractors?.map((c) => ({
                  label: `${c.first_name} ${c.last_name}`,
                  value: c.id,
                }))}
              />
            </div>

            <div className="mt-10">
              <label className="mb-2 text-sm flex items-center">
                <FormattedMessage
                  id="RECRUITER.CUSTOMER.INPUT.TEXTAREA.TITLE.REMARKS"
                  defaultMessage="Remarks"
                />
              </label>

              <textarea
                rows={4}
                value={formik.values.remarks}
                onChange={(e) =>
                  formik.setFieldValue("remarks", e.target.value)
                }
                className="block p-2.5 w-full text-sm bg-gray-50 border border-gray-300 rounded-lg"
                placeholder={intl.formatMessage({
                  id: "RECRUITER.CUSTOMER.INPUT.TEXTAREA.PLACEHOLDER",
                  defaultMessage: "Write your note here...",
                })}
              />
            </div>
          </form>
        </ModelWrapperWithButton>

        <Button
          onClick={() => setaddlocation(true)}
          text={
            <FormattedMessage
              id="RECRUITER.CUSTOMER.ADDLOCATION.BUTTON"
              defaultMessage="Add Location"
            />
          }
        />

        <ContentWithSpinner loader={loader === "location"}>
          {customerLocations.length > 0 && (
            <>
              <Location
                HandleViewLocation={HandleViewLocation}
                HandleEditLocation={HandleEditLocation}
                handleDeleteLocation={handleDeleteLocation}
                data={customerLocations}
              />

              <Pagination page={page} totalPage={totalPage} setPage={setPage} />
            </>
          )}
        </ContentWithSpinner>
      </div>

      <ModelWrapperWithButton
        nofooter
        showModal={LocationView}
        onCheckModel={onCheckModel}
      >
        <LocationDetailsView id={locationId} />
      </ModelWrapperWithButton>

      {customerLocations?.length > 0 && (
        <Button
          onClick={() => props?.TabHandle("Checklist")}
          text={
            <FormattedMessage
              id="RECRUITER.CUSTOMER.NEXT.BUTTON"
              defaultMessage="Next"
            />
          }
        />
      )}
    </>
  );
};
